export default __webpack_public_path__ + "static/media/vortex.008bbec7.webp";